import { useEffect, useRef } from 'react';

const useInterval = (callback, interval) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      savedCallback.current();
    }, interval);

    return () => clearInterval(intervalId);
  }, [interval]);
};

export default useInterval;
